<template>
  <div class="saved-item-content">
    <div class="saved-item-details">
      <figure class="saved-item-img-wrapper">
        <img :src="savedItemImg(item.img)" alt="saved item" />
      </figure>
      <!-- Template based off of Cart Item -->
      <div class="saved-item item__details-item">
        <a href="#" class="item__details-name">
          <span class="item__details-brand">{{ item.brand }}</span>
          Deva 60 Pack - Women's
        </a>
        <span class="item__details-color">{{ item.color }}</span>
        <span class="item__details-size">{{ item.size }}</span>
        <span class="item__details-sku">#{{ item.sku }}</span>

        <div class="item__details-buttons">
          <button
            :id="`move-to-cart-btn-${item.sku}`"
            type="button"
            class="btn btn--small"
            @click="$emit('move-to-cart', item.id)"
          >
            Move to cart
          </button>
          <button
            :id="`remove-btn-${item.sku}`"
            type="button"
            class="btn btn--small"
            @click="$emit('remove-from-saved', item.id)"
          >
            Remove
          </button>
        </div>
      </div>
    </div>
    <div class="saved-item-prices">
      <!-- Todo: This should be quantity? Mock has two prices. Out of scope for now. -->
      <div class="saved-item-price">
        <p>${{ formattedSavedItemPrice(item.price) }}</p>
      </div>
      <div class="saved-item-price">
        <p>${{ formattedSavedItemPrice(item.price) }}</p>
      </div>
      <div class="saved-item-price"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    /*
    Provides the image path for the product image
    */
    savedItemImg(imageSrc) {
      return require(`@/assets/${imageSrc}`);
    },

    /* Formats the price number so it's padded with zeroes
     */
    formattedSavedItemPrice(price) {
      return price.toFixed(2);
    },
  },
};
</script>

<style lang="scss">
@import "../styles/globals/globals.scss";
@import "../styles/CartItem.scss";

.saved-item.container {
  padding-top: 0;
}

.saved-item-header {
  font-size: $font-size-3xl;
  padding-top: 20px;
  padding-bottom: 20px;

  @media screen {
    @media (min-width: $breakpoint-sm) {
      padding-top: 30px;
      padding-bottom: 30px;
    }
  }
}

.saved-item-content {
  display: flex;
  flex-flow: row wrap;
  box-shadow: $box-shadow;
  border-radius: 4px;
  border: 1px solid $lighter-grey;
}

.saved-item-content:not(:last-of-type) {
  margin-bottom: 30px;
}

.saved-item-details,
.saved-item-prices {
  width: 100%;

  @media screen {
    @media (min-width: $breakpoint-md) {
      width: 50%;
    }
  }
}

.saved-item-details {
  display: flex;
  flex-flow: row wrap;
}

.saved-item-prices {
  display: flex;
  flex-flow: row wrap;
  text-align: right;
}

.saved-item-prices .saved-item-price {
  width: 33%;
}

.saved-item-img-wrapper {
  max-width: 30%;
  margin-right: 50px;
  padding-top: 20px;

  @media screen {
    @media (min-width: $breakpoint-sm) {
      width: 100%;
    }
  }
}

.saved-item-img-wrapper img {
  max-width: 100%;
}

.saved-item .item__details-item {
  padding: 30px;
}
</style>
